@if (userService.isUserConnected()) {
  <div class="container">
    <div class="buttons-container">
      <ml-navigation-card
        [title]="'application.home.new-offer' | translate"
        (cardClicked)="navigateTo('/simulation')"
        [isClickable]="true"
      ></ml-navigation-card>
      <ml-navigation-card
        [title]="'application.home.transmitted-folders' | translate"
        [content]="folderNumber ? ('application.home.transmitted-folders-subtitle' | translate: { folderNumber }) : ''"
        (cardClicked)="navigateTo('/records')"
        [isClickable]="true"
      ></ml-navigation-card>
      <ml-navigation-card
        [title]="'application.home.see-leads' | translate"
        (cardClicked)="navigateTo('/leads')"
        [isClickable]="true"
      ></ml-navigation-card>
    </div>
  </div>
}
